import type { DisplayCurrency } from './types'

export function currencySymbol(currency: DisplayCurrency): string {
  switch (currency) {
    case 'USD':
      return '$'
    case 'AUD':
      return 'A$'
    case 'GBP':
      return '£'
    case 'EUR':
      return '€'
    default:
      return '$'
  }
}

export function formatMoneyAmount(amount: number, currency: DisplayCurrency): string {
  const sym = currencySymbol(currency)
  const value = amount.toFixed(2)
  if (currency === 'EUR') return `${value} €`
  return `${sym}${value}`
}
